
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Why <span className="text-spharaka-purple">Spharaka Networks</span>?</h1>
          <p className="text-xl text-gray-600 mb-6">
            Discover how Spharaka Networks' revolutionary approach to cybersecurity is transforming the 
            way organizations detect, investigate, and respond to threats.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-10">
            <div className="flex items-center px-4 py-2 bg-spharaka-purple/10 rounded-full">
              <span className="text-sm font-medium">Advanced Threat Detection</span>
            </div>
            <div className="flex items-center px-4 py-2 bg-spharaka-purple/10 rounded-full">
              <span className="text-sm font-medium">Intelligent Investigation</span>
            </div>
            <div className="flex items-center px-4 py-2 bg-spharaka-purple/10 rounded-full">
              <span className="text-sm font-medium">Response</span>
            </div>
            <div className="flex items-center px-4 py-2 bg-spharaka-purple/10 rounded-full">
              <span className="text-sm font-medium">AuraXP</span>
            </div>
            <div className="flex items-center px-4 py-2 bg-spharaka-purple/10 rounded-full">
              <span className="text-sm font-medium">24/7 Protection</span>
            </div>
          </div>
          <p className="text-lg text-gray-600 mb-8">
            In today's rapidly evolving threat landscape, traditional security solutions are no longer enough. 
            Spharaka Networks combines cutting-edge AuraXP technology with industry-leading security expertise to 
            provide comprehensive protection against advanced threats, all while reducing operational burden 
            on your security team.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="cta" className="bg-spharaka-purple hover:bg-spharaka-purple/90">
              <Link to="/products/auraxp">Explore AuraXP™</Link>
            </Button>
            <Button asChild size="cta" variant="outline" className="border-spharaka-purple text-spharaka-purple hover:bg-spharaka-purple hover:text-white">
              <Link to="/products/spharakaxdr">Explore Autonomous Cyber Defence</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
